import styles from "./Integrations.module.css";

export default function Integrations() {
  const shopifyStats = [
    { value: "1,200+", label: "Pieces in Atelier", color: "var(--accent-light)", textColor: "var(--accent-dark)" },
    { value: "9,800", label: "Clients Dressed", color: "var(--primary-light)", textColor: "var(--ink)" },
    { value: "40+", label: "Master Tailors", color: "var(--accent-light)", textColor: "var(--accent-dark)" },
    { value: "98.5%", label: "Fit Satisfaction", color: "var(--primary-light)", textColor: "var(--ink)" },
  ];

  const socialChannels = [
    {
      icon: "📱",
      name: "WhatsApp Concierge",
      desc: "Personal styling on demand",
      handle: "+20 108 097 2433",
      features: ["Instant styling chat", "Order updates", "Fitting appointments", "Avg Response: 5 min"],
      btnClass: styles.whatsapp,
      btnLabel: "Open WhatsApp",
      href: "https://wa.me/201080972433?text=Hello%20Atelier%20Noir",
    },
    {
      icon: "📘",
      name: "Facebook Messenger",
      desc: "Connect via Facebook",
      handle: "@AtelierNoir",
      features: ["Messenger styling", "Lookbook sharing", "Client support", "Avg Response: 15 min"],
      btnClass: styles.facebook,
      btnLabel: "Open Messenger",
      href: "https://m.me/ateliernoir",
    },
    {
      icon: "📷",
      name: "Instagram DM",
      desc: "Direct messages on Instagram",
      handle: "@ateliernoir",
      features: ["New arrivals", "Story replies", "Style inquiries", "Avg Response: 30 min"],
      btnClass: styles.instagram,
      btnLabel: "Open Instagram",
      href: "https://instagram.com/ateliernoir",
    },
  ];

  const paymentMethods = [
    {
      icon: "💳",
      name: "Card Payment",
      desc: "Visa, MasterCard, Amex",
      features: ["PCI DSS Compliant", "Instant processing", "Secure encryption"],
    },
    {
      icon: "🚚",
      name: "Cash on Delivery",
      desc: "Pay when your order arrives",
      features: ["No upfront payment", "Try before you pay", "Safe & secure"],
    },
  ];

  return (
    <div className={styles.page}>
      <div className="container">
        <div className={styles.pageHeader}>
          <span className="eyebrow">The House of Atelier Noir</span>
          <h1>The Atelier</h1>
          <p>Master tailoring, curated collections, and concierge service — connected in one experience.</p>
        </div>

        <section className={styles.section}>
          <div className={styles.sectionTitleRow}>
            <span className={styles.sectionIcon}>🧵</span>
            <div>
              <h2>The Atelier in Numbers</h2>
              <p>Craft and care, measured</p>
            </div>
          </div>
          <div className={styles.statsGrid}>
            {shopifyStats.map((s) => (
              <div key={s.label} className={styles.statCard} style={{ background: s.color }}>
                <p className={styles.statValue} style={{ color: s.textColor }}>{s.value}</p>
                <p className={styles.statLabel}>{s.label}</p>
              </div>
            ))}
          </div>
          <div className={styles.featureList}>
            <p className={styles.featureListTitle}>What sets us apart:</p>
            {["Made-to-measure tailoring", "Complimentary alterations", "Curated seasonal collections", "Personal style concierge"].map((f) => (
              <div key={f} className={styles.featureItem}>✓ {f}</div>
            ))}
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Connect With Our Stylists</h2>
          <div className={styles.socialGrid}>
            {socialChannels.map((ch) => (
              <div key={ch.name} className={styles.socialCard}>
                <div className={styles.socialIcon}>{ch.icon}</div>
                <h3>{ch.name}</h3>
                <p className={styles.socialDesc}>{ch.desc}</p>
                <p className={styles.socialHandle}>{ch.handle}</p>
                <div className={styles.socialFeatures}>
                  {ch.features.map((f) => (
                    <div key={f} className={styles.socialFeatureItem}>✓ {f}</div>
                  ))}
                </div>
                <button
                  className={`${styles.socialBtn} ${ch.btnClass}`}
                  onClick={() => window.open(ch.href, "_blank")}
                >
                  {ch.btnLabel}
                </button>
              </div>
            ))}
          </div>
        </section>

        <section className={styles.section}>
          <div className={styles.sectionTitleRow}>
            <span className={styles.sectionIcon}>💳</span>
            <div>
              <h2>Payment Methods</h2>
              <p>Secure payment processing</p>
            </div>
          </div>
          <div className={styles.paymentGrid}>
            {paymentMethods.map((m) => (
              <div key={m.name} className={styles.paymentCard}>
                <h4 className={styles.paymentName}>{m.icon} {m.name}</h4>
                <p className={styles.paymentDesc}>{m.desc}</p>
                <div className={styles.paymentFeatures}>
                  {m.features.map((f) => <div key={f}>✓ {f}</div>)}
                </div>
              </div>
            ))}
          </div>
        </section>


      </div>
    </div>
  );
}
